import { getPromoCodeForUpgradeOffer } from 'utils/api/bonus';
import { getCookie } from 'utils/cookie';
import Router from 'next/router';

export const goUpgradeOffer = async () => {
  const jwt = getCookie('jwt');
  const { promoCode } = await getPromoCodeForUpgradeOffer(jwt);
  await Router.push(`/account/subscriptions/upgrade?code=${promoCode}`);
};
